import { useFormState } from 'react-final-form';

import { useFormConfig } from 'config/formConfig/hooks';
import { PURPOSE_KIND, PURPOSE_KIND__OVERDRAFT_LIQUIDITY } from 'modules/Inquiry/Form/formFields';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';

const useAmountTranslations = () => {
  const { values } = useFormState();
  const selectedPurposeKind = values[PURPOSE_KIND];
  const { selectedInquiryType } = useFormConfig();

  let formSectionTitle = 'pages.financingNeed.sections.amount.title';
  let financingAmountCaption = 'pages.financingNeed.sections.amount.fields.financingAmount.caption';
  if (selectedInquiryType === InquiryType.bfs) {
    financingAmountCaption = 'pages.financingNeed.sections.purpose.fields.purposeKind.bfsCaption';
    if (selectedPurposeKind === PURPOSE_KIND__OVERDRAFT_LIQUIDITY) {
      formSectionTitle = 'pages.financingNeed.sections.amount.bfsLiquidityTitle';
      financingAmountCaption =
        'pages.financingNeed.sections.purpose.fields.purposeKind.bfsLiquidityCaption';
    }
  }
  return {
    formSectionTitle,
    financingAmountCaption,
  };
};

export default useAmountTranslations;
